import TeamApi from "../api/teamApi";
import * as types from "./actionTypes";

function getAllTeamsStarted() {
  return { type: types.TEAMS_GET_ALL_STARTED };
}
function getAllTeamsFulfilled(teams: any) {
  return { type: types.TEAMS_GET_ALL_FULFILLED, payload: teams };
}
function getAllTeamsRejected(error: any) {
  return {
    type: types.TEAMS_GET_ALL_REJECTED,
    payload: { message: error.message, stack: error.stack },
  };
}

export function getAllTeams() {
  return (dispatch: any) => {
    dispatch(getAllTeamsStarted());
    TeamApi.getAllTeams()
      .then((teams) => dispatch(getAllTeamsFulfilled(teams)))
      .catch((er) => dispatch(getAllTeamsRejected(er)));
  };
}
